import React from 'react'
import Slider from "react-slick";
import styled from 'styled-components';

const Header = () => {

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        fade: true,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 3000,
        cssEase: "linear"
    };

    return (
        <Head>
            <Slider {...settings}>
                <Carosol className="first">
                    <video autoPlay muted loop>
                        <source src="/images/1.mp4" />
                    </video>
                    <Overlay>
                        <span>#3D #3D RENDERING</span>
                        <h1>Hii, Welcome to my Portfolio</h1>
                    </Overlay>
                    <Box>
                        <h1>Low Poly Models</h1>
                        <h1>Made with ❤ by Mukul Rajpoot</h1>
                    </Box>
                </Carosol>
                <Carosol className="second">
                    <video autoPlay muted loop>
                        <source src="/images/2.mp4" />
                    </video>
                    <Overlay>
                        <span>#3D #3D RENDERING</span>
                        <h1>Even smaller Models presented in a unique and sublime way</h1>
                    </Overlay>

                    <Box>
                        <h1>Models for Games</h1>
                        <h1>Made with ❤ by Mukul Rajpoot</h1>
                    </Box>
                </Carosol>
                <Carosol className="third">
                    <Overlay>
                        <span>#3D #3D RENDERING</span>
                        <h1>I create 3D models so you don't have to</h1>
                    </Overlay>
                    <Box>
                        <h1>Optimised Models</h1>
                        <h1>Made with ❤ by Mukul Rajpoot</h1>
                    </Box>
                </Carosol>
            </Slider>
        </Head>
    )
}

const Head = styled.div`
    overflow-x: hidden;

    .first {
        background: url('/images/16.png');
        background-position: center;
        background-size: cover;
    }
    .second{
        background: url('/images/12.png');
        background-position: center;
        background-size: cover;
    }
    .third{
        background: url('/images/14.png');
        background-position: center;
        background-size: cover;
    }
`;

const Carosol = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;


    & > video {
        position: absolute;
        height: 100vh;
        width: 100%;
        object-fit: cover;
    }
`;

const Box = styled.section`
    position: absolute;
    width: 75%;
    height: 10vh;
    left: 0%;
    bottom: 0%;
    background: white;
    z-index: 100;
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    padding: 0 5rem;
    `

const Overlay = styled.div`
    height: 100%;
    width: 100%;
    position: absolute;
    padding: 0 15rem;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background: rgba(0,0,0,0.5);
    color: #fff;
    font-size: 2rem;

    @media (max-width: 768px) {
        padding: 0 5rem;
    }

    & > h1 {
        font-size: 10rem;
        color: #fff;
        font-family: 'Bebas Neue', cursive;
        max-width: 50%;

        @media (max-width: 768px) {
            font-size: 5rem;
            max-width: 100%;
        }
    }
`

export default Header
